import { checkScenario } from '@mfe/util/scenario';
import { ApiLoadConsentResponse, ConsentSaveType } from '@mfe/types/common';
import { CustomerAttribute } from '@mfec/customerAttributes/types';
import { getTracingHeaders } from '../util/helpers';
import HttpClient from './HttpClient';
import { ConfigState } from '../store/config';
import { AuthState } from '../store/auth';

abstract class ClientAbstract {
  protected httpClient: HttpClient;

  protected config: ConfigState;

  protected auth: AuthState;

  constructor(config: ConfigState, auth: AuthState) {
    const {
      apiUri, accessToken: configAccessToken, customerToken, traceid,
    } = config;
    const { accessToken: comsInternalAccessToken } = auth;

    const { isRaittNoTokensWithInterception, isAuthOverride } = checkScenario(config);

    const headers: Record<string, string> = {
      Accept: 'application/json; charset=utf-8',
      ...getTracingHeaders(traceid),
    };

    if (!isRaittNoTokensWithInterception) {
      headers.Authorization = configAccessToken
        ? `Bearer ${configAccessToken}`
        : `Access ${comsInternalAccessToken}`;
    }

    if (isAuthOverride) {
      headers['x-authorization-override'] = customerToken
        ? `Customer ${customerToken}`
        : `Access ${comsInternalAccessToken}`;
    }

    this.httpClient = new HttpClient(apiUri, headers);
    this.config = config;
    this.auth = auth;
  }

  abstract getConsents(lifecycle: string): Promise<ApiLoadConsentResponse>;
  abstract saveConsents(data: ConsentSaveType[], customerAttributeData: CustomerAttribute[]): Promise<void>;

  getCustomerInfoFromConfigOrAuth(): { lcId?: string, registerId?: string, spId: string } {
    const source = this.auth.spId
      ? this.auth // take details from `GET /token` or `GET /userprofile`
      : this.config; // take details from MF configuration
    return {
      spId: source.spId,
      lcId: source.lcId,
      registerId: source.registerId,
    };
  }
}

export default ClientAbstract;
